module.exports = __webpack_public_path__ + "img/chayiem.d1dd03f9.jpeg";